import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'

@Component({
    selector: 'app-company',
    templateUrl: './company.component.html',
    styleUrls: ['../promotion.component.css'],
})
export class CompanyComponent implements OnInit {
    en = {}
    showEN = true

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

}



// WEBPACK FOOTER //
// ./src/app/promotion/company/company.component.ts